/**
 * Класс для управления стеком модальных окон.
 */
export class ModalStack {
  private stack: string[] = []
  private currentModal: string | null = null

  /**
   * Добавляет модальное окно в стек.
   * @param {string} modalName - Имя модального окна.
   */
  public push(modalName: string): void {
    this.stack.push(modalName)
    this.currentModal = modalName
  }

  /**
   * Удаляет последнее модальное окно из стека.
   * @return {string | undefined} Имя удаленного модального окна.
   */
  public pop(): string | undefined {
    const popped = this.stack.pop()
    this.currentModal = this.stack[this.stack.length - 1] || null
    return popped
  }

  /**
   * Возвращает текущее модальное окно.
   * @return {string | null} Имя текущего модального окна.
   */
  public getCurrent(): string | null {
    return this.currentModal
  }

  /**
   * Устанавливает текущее модальное окно.
   * @param {string | null} modalName - Имя модального окна.
   */
  public setCurrent(modalName: string | null): void {
    this.currentModal = modalName
  }

  /**
   * Возвращает предыдущее модальное окно из стека.
   * @return {string | null} Имя предыдущего модального окна.
   */
  public getPrevious(): string | null {
    const length = this.stack.length
    return length > 1 ? this.stack[length - 2] : null
  }

  /**
   * Возвращает количество элементов в стеке.
   * @return {number} Количество элементов в стеке.
   */
  public getLength(): number {
    return this.stack.length
  }

  /**
   * Очищает стек модальных окон.
   */
  public clear(): void {
    this.stack.length = 0
    this.currentModal = null
  }

  /**
   * Проверяет, пуст ли стек.
   * @return {boolean} true, если стек пуст.
   */
  public isEmpty(): boolean {
    return this.stack.length === 0
  }
}
